module.exports = __webpack_public_path__ + "img/cursoGestao.50be36a3.png";